import React from "react";
import styled from "styled-components";
import { colors } from "utils";
import { criticalIncidents } from "utils/taggedQuotes";
import { questionRef } from "./ParsedSummary/quotes";
import {
  INCIDENTS_HEADING,
  IncidentsDisclaimer,
  IncidentTagChip,
} from "../shared/criticalIncidentsUi";

// The session report's Critical Incidents tab: the same listing the lesson
// report card shows, scoped to one session. A quote is a button rather than a
// link — the transcript is a sibling tab, so it switches tabs and highlights
// the utterance instead of navigating away.
export const CriticalIncidentsTab = ({ taggedQuotes, onQuoteClick }) => {
  const incidents = criticalIncidents(taggedQuotes);

  return (
    <Wrapper>
      <SectionHeading>{INCIDENTS_HEADING}</SectionHeading>
      <BodyText>
        <IncidentsDisclaimer />
      </BodyText>
      <InstanceCount>
        {incidents.length} {incidents.length === 1 ? "Instance" : "Instances"}
      </InstanceCount>
      <IncidentList>
        {incidents.map((incident, i) => (
          <IncidentItem key={i}>
            <IncidentLine>
              <IncidentStudent>
                {incident.studentName}
                {questionRef(incident.qNum)}
              </IncidentStudent>
              <IncidentTagChip tag={incident.tag} />
            </IncidentLine>
            <IncidentQuote
              type="button"
              onClick={() =>
                onQuoteClick({
                  text: incident.quote,
                  timestamp: incident.quote_timestamp,
                })
              }
            >
              &ldquo;{incident.quote}&rdquo;
            </IncidentQuote>
          </IncidentItem>
        ))}
      </IncidentList>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 8px;
`;

const SectionHeading = styled.h3`
  font-family: "ABC Marfa", sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: ${colors.nightlyWoods500};
  margin: 16px 0 0;
`;

const BodyText = styled.p`
  font-family: Inter, sans-serif;
  font-size: 16px;
  line-height: 22px;
  color: ${colors.nightlyWoods500};
  margin: 0;
`;

const InstanceCount = styled.div`
  font-family: Inter, sans-serif;
  font-size: 18px;
  line-height: 26px;
  color: ${colors.nightlyWoods500};
`;

const IncidentList = styled.ul`
  margin: 0;
  padding-left: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const IncidentItem = styled.li`
  font-family: Inter, sans-serif;
  font-size: 18px;
  line-height: 26px;
  color: ${colors.nightlyWoods500};
`;

const IncidentLine = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

const IncidentStudent = styled.span`
  font-weight: 700;
`;

const IncidentQuote = styled.button`
  display: block;
  background: none;
  border: none;
  text-align: left;
  padding: 4px 24px 0;
  font-family: Inter, sans-serif;
  font-size: 16px;
  line-height: 22px;
  color: ${colors.blue700};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${colors.blue800};
  }
`;
